/**
 * Operation name of feature.country.query.gql. Refetched after a save: the
 * mutation returns rows with no cache identity of their own, so the query's
 * cached result is what has to be replaced.
 */
export const FEATURE_COUNTRY_QUERY_NAME = "FeatureCountryQuery"

/**
 * What an EMPTY country list means for a feature. It depends on how the
 * console reads the type (see COUNTRY_GATED_FEATURE_TYPE_CODES): a map layer
 * or basemap with no country is offered nowhere, any other feature with no
 * country is offered everywhere. The picker's copy and warnings follow this.
 */
export const COUNTRY_EMPTY_MEANING = {
  everywhere: "everywhere",
  nowhere: "nowhere",
} as const

export type CountryEmptyMeaning =
  (typeof COUNTRY_EMPTY_MEANING)[keyof typeof COUNTRY_EMPTY_MEANING]
